import { Sentry } from "../config/sentry.client";
import { reportError, type ErrorReportContext } from "./error-reporting";

export const reportToSentry = (error: unknown, context?: ErrorReportContext) =>
  reportError(Sentry, error, context);
